"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrayField = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_jss_1 = __importDefault(require("react-jss"));
const icons_1 = require("../../../../icons");
const button_1 = __importDefault(require("../../ui/button"));
const arrayField_style_1 = __importDefault(require("./arrayField.style"));
class ArrayField extends react_1.PureComponent {
    render() {
        const { classes, title, items, canAdd, onAddClick, rawErrors } = this.props;
        const error = rawErrors && rawErrors.length > 0;
        return (jsx_runtime_1.jsxs("div", Object.assign({ className: classes.root, "data-has-error": error }, { children: [jsx_runtime_1.jsx("div", Object.assign({ className: classes.styledDiv }, { children: title }), void 0),
                items.map(item => (jsx_runtime_1.jsxs("div", Object.assign({ className: classes.fieldWrapper }, { children: [item.children, item.hasRemove && (jsx_runtime_1.jsx("div", Object.assign({ className: classes.styledBox }, { children: jsx_runtime_1.jsx(button_1.default, Object.assign({ onClick: e => {
                                    item.onDropIndexClick(item.index)(e);
                                } }, { children: jsx_runtime_1.jsx(icons_1.Icon, { name: "Trash", size: 30 }, void 0) }), void 0) }), void 0))] }), item.index))),
                canAdd && (jsx_runtime_1.jsx(button_1.default, Object.assign({ onClick: onAddClick }, { children: jsx_runtime_1.jsx(icons_1.Icon, { name: "CirclePlus", size: 30 }, void 0) }), void 0))] }), void 0));
    }
}
exports.ArrayField = ArrayField;
ArrayField.defaultProps = {
    rawErrors: []
};
exports.default = react_jss_1.default(arrayField_style_1.default)(ArrayField);
//# sourceMappingURL=index.js.map